import React from 'react'

import PartnerBanner from 'components/PartnerBanner'
import ReferralBanner from 'components/ReferralBanner'

import { enhance } from './enhance'
import FullNav from './FullNav'
import MiniNav from './MiniNav'
import { EnhancedNavProps } from './types'

function NavComponent(props: EnhancedNavProps) {
  if (props.flow === 'spend') {
    // Spend flow is deprecated, thus MiniNav
    return <MiniNav {...props} />
  } else {
    return <FullNav {...props} />
  }
}

export const Nav: React.FC<EnhancedNavProps> = props => (
  <>
    {props.referralAmount && <ReferralBanner amount={props.referralAmount} />}
    {props.partnerLogo && <PartnerBanner logo={props.partnerLogo} />}
    <NavComponent {...props} />
  </>
)

export default enhance(Nav)
